<template>
    <v-stepper class="pfwizard elevation-0" v-model="stepInternal">
      <v-stepper-header >
      <template v-for="(s,i) in steps">
      <v-stepper-step
        :color="step == i+1 ? 'primary' : 'secondary'"
        :complete="(i+1) < step || i < lastEditableStep"
        :step="i+1"
        :key="`${i+1}-step`"
        :editable="s.editable && allowEditable && i <= lastEditableStep"
      >
        {{ $t(s.title) }}
      </v-stepper-step>
      <v-divider
            v-if="i !== steps.length - 1"
            :key="`${i+1}-divider`"
          ></v-divider>
      </template>
      </v-stepper-header>
    </v-stepper>
</template>

<script>
export default {
    name: 'WizardStepper',
    props: { steps: {type: Array, required: true }, step: {type: Number, default: 1 }, allowEditable: Boolean, lastEditableStep: Number },
    data() {
      return {
        stepInternal: this.step
      }
    },
    watch: {
      step(val) {
        this.stepInternal = val;
      },
      stepInternal(val) {
        this.$emit('update:step', val);
        this.$emit('click-step', { display: val, index: val-1 });
      }
    }
}
</script>